import { forwardRef, type TextareaHTMLAttributes } from 'react'

import { chromeComposerTextareaShellClass } from './ChromeSurface'

export type ChromeComposerTextareaVariant = 'composer' | 'form'

type Props = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'className'> & {
  angular: boolean
  /** composer：生图提示词区；form：表单/弹窗多行输入 */
  variant?: ChromeComposerTextareaVariant
  /** 外层描边容器额外 class */
  className?: string
  /** textarea 额外 class */
  textareaClassName?: string
}

const SHELL_BY_VARIANT: Record<ChromeComposerTextareaVariant, string> = {
  composer: '',
  form: 'mt-1.5',
}

const TEXTAREA_BY_VARIANT: Record<ChromeComposerTextareaVariant, string> = {
  composer:
    'min-h-[4.5rem] text-[14px] leading-relaxed sm:text-[15px] lg:min-h-[5.25rem]',
  form: 'min-h-[3rem] text-sm leading-relaxed',
}

/**
 * 与生图页提示词输入一致：外框 chromeField + 内层无滚动条、无右下角拖拽的多行输入。
 * 内容超出时仍可滚轮/触摸滑动，但不显示滚动条。
 */
export const ChromeComposerTextarea = forwardRef<HTMLTextAreaElement, Props>(
  function ChromeComposerTextarea(
    { angular, variant = 'form', className = '', textareaClassName = '', rows, ...rest },
    ref,
  ) {
    return (
      <div
        className={[
          chromeComposerTextareaShellClass(angular),
          SHELL_BY_VARIANT[variant],
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <textarea
          ref={ref}
          rows={rows ?? (variant === 'composer' ? 5 : 4)}
          className={[
            'glyphicai-scrollbar-none block w-full min-h-0 flex-1 resize-none overflow-y-auto bg-transparent p-0 text-ink outline-none placeholder:text-ink-soft',
            TEXTAREA_BY_VARIANT[variant],
            textareaClassName,
          ]
            .filter(Boolean)
            .join(' ')}
          {...rest}
        />
      </div>
    )
  },
)
